import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "twig",
  extensions: [".twig"],
  aliases: ["Twig", "twig"],
  mimetypes: ["text/x-twig"],
  loader: () => import('./twig.js')
});
